document.addEventListener('DOMContentLoaded', function() {
    var showMoreButtons = document.querySelectorAll('.show-more-button');
    
    showMoreButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var content = button.previousElementSibling;
            if (content && content.classList.contains('rte__content')) {
                content.classList.add('expanded');
                button.classList.add('hidden');
            }
        });
    });
}); 